import PropTypes from 'prop-types'

import styles from './TextInput.module.scss'

const TextInput = ({
  type = 'text',
  label,
  className,
  valid,
  children,
  forwardedRef,
  value,
  onChangeValue,
  maxLength,
  ...props
}) => (
  <label className={[styles.container, className ? className : ''].join(' ')}>
    {label && <span className={styles.label}>{label}</span>}
    <input
      className={[
        styles.input,
        valid === true ? styles.inputSuccess : '',
        valid === false ? styles.inputError : ''
      ].join(' ')}
      ref={forwardedRef}
      onChange={e => onChangeValue(e.target.value)}
      {...props}
      autoComplete="off"
      type={type}
      value={typeof value !== 'undefined' ? value : undefined}
      maxLength={maxLength}
      onFocus={e => {
        if (type === 'number') {
          e.target.value = e.target.value.replace(/^0+/, '')
        }
      }}
    />
    {children}
  </label>
)

TextInput.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  succeded: PropTypes.bool,
  errored: PropTypes.bool
}

export default TextInput
